import { AppState } from '../../../state/app-state';
import { CreateProfileState } from './create-profile-state';

export const selectCreateProfileState: (
    state: AppState,
) => CreateProfileState = (state: AppState) => state.createProfile;
